const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Orders kanban", "uipress-lite"),
  moduleName: "orders-kanban",
  description: __("Creates a kanban view of recent woocommerce orders and allows for drag and drop management", "uipress-lite"),
  group: "dynamic",
  icon: "view_kanban",
};
